import { render, staticRenderFns } from "./NetworkCard.vue?vue&type=template&id=16f1c897&scoped=true"
import script from "./NetworkCard.vue?vue&type=script&lang=js"
export * from "./NetworkCard.vue?vue&type=script&lang=js"
import style0 from "./NetworkCard.vue?vue&type=style&index=0&id=16f1c897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1c897",
  null
  
)

export default component.exports